import { isFulfilled, isPending, isRejected, Middleware, MiddlewareAPI } from "@reduxjs/toolkit";
import { LoadingState, setError, setIsLoading } from "./slice/appStateSlice";

export interface IAppLoaderAction {
  componentId?: string;
}

/**
 * Catch the fullfilled, pending and rejected actions from asyncChunk and dispatch setIsLoading and setError actions from @appStateSlice
 */
export const loadingHandler: Middleware = (api: MiddlewareAPI) => (next) => (action) => {
  if (action.meta && action.meta.arg && action.meta.arg.componentId) {
    const componentId = action.meta.arg.componentId;
    if (isPending(action)) {
      api.dispatch(setError({ componentId, error: "" }));
      api.dispatch(setIsLoading({ componentId, loading: LoadingState.Loading }));
    }
    if (isFulfilled(action)) {
      api.dispatch(setIsLoading({ componentId, loading: LoadingState.Success }));
    }
    if (isRejected(action)) {
      api.dispatch(setIsLoading({ componentId, loading: LoadingState.Idle }));
      try {
        // Priority 1: Check for Strapi v4 error format (action.payload.error.message)
        if (action.payload && action.payload.error && action.payload.error.message) {
          api.dispatch(setError({ componentId, error: action.payload.error.message }));
        }
        // Priority 2: Check for standard Redux Toolkit error (action.error.message)
        else if (action.error && action.error.message) {
          api.dispatch(setError({ componentId, error: action.error.message }));
        }
        // Priority 3: Check for old Strapi v3 format (action.payload.data[0].messages)
        else if (action.payload && action.payload.data) {
          const errorMessages = action.payload.data[0].messages
            .map((errorElem: { id: string; message: string }) => errorElem.message)
            .join(" ");
          api.dispatch(setError({ componentId, error: errorMessages }));
        }
        // Fallback
        else {
          api.dispatch(setError({ componentId, error: "An error occured" }));
        }
      } catch (ex) {
        console.error(ex);
        api.dispatch(setError({ componentId, error: "An error occured" }));
      }
    }
  }

  return next(action);
};
